var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceFilePreview = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#etfgiqiura)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#FF3F6D"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44 9H14a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V13a4 4 0 0 0-4-4z",
  fill: "#FF3F6D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.82 27.32a.84.84 0 0 0-.18-.52 24.562 24.562 0 0 0-4-4c-2.35-1.9-5.59-3.8-9.28-3.8-3.69 0-6.86 1.9-9.23 3.8a24.563 24.563 0 0 0-3.95 4 .84.84 0 0 0-.18.52.87.87 0 0 0 .18.53 25.864 25.864 0 0 0 4 4c2.35 1.9 5.58 3.79 9.28 3.8 3.7.01 6.93-1.9 9.28-3.8a24.998 24.998 0 0 0 4-4 .87.87 0 0 0 .08-.53zm-5.81 3.61a13.08 13.08 0 0 1-7.6 3 13.14 13.14 0 0 1-7.61-3 25.077 25.077 0 0 1-3.81-3.61 25.64 25.64 0 0 1 3.81-3.6 13.14 13.14 0 0 1 7.61-3 13.08 13.08 0 0 1 7.6 3 25.14 25.14 0 0 1 3.81 3.6 24.596 24.596 0 0 1-3.81 3.61z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7 27.32a4.71 4.71 0 1 1 9.42.02 4.71 4.71 0 0 1-9.42-.02zm4.71-3a3 3 0 1 0 3 3 3 3 0 0 0-3-2.97v-.03z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "etfgiqiura",
  x: 0,
  y: 0,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.054902 0 0 0 0 0.203922 0 0 0 0 0.454902 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_255_4140"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_255_4140",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceFilePreview);
export default ForwardRef;